import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const ButtonLinkWrapper = styled.div`
  margin-top: ${spacing.space24};
`;
